import reduceReducers from 'reduce-reducers'

import { DICTIONARY_WORDS_INITIAL_STATE } from '../initial-states'

import dictionaryWordModalsReducer from './dictionary-word-modals-reducer'
import dictionaryWordReducer from './dictionary-word-reducer'
import dictionaryWordsReducer from './dictionary-words-reducer'

export default reduceReducers(
  DICTIONARY_WORDS_INITIAL_STATE,
  dictionaryWordsReducer,
  dictionaryWordReducer,
  dictionaryWordModalsReducer,
)
